import { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  TextFielDecimalNumbers
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import { GrupoPessoasService } from "../../../services";
import { cacheApi, responseErros, unformatPrice } from "../../../utils";
import { constantes } from "../../pessoas/addPessoa/resources";

export default function TabPrestadorServico({
  prestadorSelecionado,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [prestadorServico, setPrestadorServico] = useState(prestadorSelecionado);

  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 5,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    prestadorSelecionado.setAtributo(name, value?.id);
    setPrestadorServico({ ...prestadorSelecionado });
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    prestadorSelecionado.setAtributo(name, value);
    setPrestadorServico({ ...prestadorSelecionado });
  };

  const handleChangeCurrencyInput = (event) => {
    const { name, value } = event.target;
    const valor = unformatPrice(value);
    prestadorSelecionado.setAtributo(name, Number(valor));
    setPrestadorServico({ ...prestadorSelecionado });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={4}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) => 
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            value={value.autoComplete(
              listaGrupoPessoa,
              prestadorServico?.grupoPessoaId,
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Grupos de Pessoas"
              />
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <Select
          label="Profissão"
          id="profissao"
          name="profissao"
          margin="normal"
          required
          error={inputErros?.get(`[${linhaSelecionada}].prestadorServico.profissao`)}
          value={prestadorServico?.profissao || ""}
          onChange={handleChangeInput}
        >
          {constantes.profissoesList.map((profissao) => (
            <MenuItem key={profissao.value} value={profissao.label}>
              {profissao.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={2}>
        <TextFielDecimalNumbers
          label="Comissão - A Prazo"
          name="comissaoPrazo"
          variant="outlined"
          fullWidth
          onBlur={handleChangeCurrencyInput}
          value={prestadorServico?.comissaoPrazo ?? ""}
          error={inputErros.get("comissaoPrazo")}
        />
      </Grid>
      <Grid item xs={2}>
        <TextFielDecimalNumbers
          label="Comissão - A Vista"
          name="comissaoVista"
          variant="outlined"
          fullWidth
          onBlur={handleChangeCurrencyInput}
          value={prestadorServico?.comissaoVista ?? ""}
          error={inputErros.get("comissaoVista")}
        />
      </Grid>
    </Grid>
  );
}
